<template>
  <el-dialog
    :title="point.name"
    v-model="isShow"
    :fullscreen="isMobile"
    @open="getTasks()"
  >
    <div class="route-point__head">
      <el-tag size="mini">{{ point.address }}</el-tag>
      <el-tag size="mini" type="info" v-if="point.workingTime">
        {{ point.workingTime }}
      </el-tag>
    </div>

    <div class="tasks route-point__tasks" v-loading="loading">
      <TransitionGroup>
        <span v-for="(item, key) in taskList.process" :key="key">
          <TaskItem :item="item" />
        </span>
      </TransitionGroup>

      <div class="tasks-complite" v-if="taskList.complite.length">
        <TransitionGroup>
          <div class="tasks-complite__title">
            <el-icon><ArrowDownBold /></el-icon>
            Completed ({{ taskList.complite.length }})
          </div>
          <span v-for="(item, key) in taskList.complite" :key="key">
            <TaskItem :item="item" />
          </span>
        </TransitionGroup>
      </div>

      <el-empty
        description="No tasks"
        v-if="!loading && !taskList.process.length && !taskList.complite.length"
      ></el-empty>
    </div>
  </el-dialog>
</template>

<script>
import ApiRoute from "@/api/route";
import TaskItem from "@/components/Task/Item";
import bus from "vue3-eventbus";
import _ from "lodash";

export default {
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    point: {
      default: () => {},
      type: Object,
    },
  },
  components: {
    TaskItem,
  },
  data() {
    return {
      taskList: {
        complite: [],
        process: [],
      },
      loading: false,
      isMobile: false,
    };
  },
  computed: {
    isShow: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  methods: {
    getTasks() {
      if (!this.point || !this.point.locationId) {
        return;
      }

      this.loading = true;
      ApiRoute.getPointTasks({ locationId: this.point.locationId }).then(
        (responce) => {
          this.loading = false;
          this.handleTaskList(responce.status ? responce.data.tasks : []);
        }
      );
    },
    handleTaskList(list = []) {
      this.taskList = {
        complite: [],
        process: [],
      };

      _.each(list, (item) => {
        if (item.status === "completed") {
          this.taskList.complite.push(item);
          this.taskList.complite.sort(function (x, y) {
            return x.update - y.update;
          });
        } else {
          this.taskList.process.push(item);
        }
      });
    },
    reload() {
      if (this.isShow) {
        this.getTasks();
      }
    },
  },
  mounted() {
    if (window.innerWidth <= 768) {
      this.isMobile = true;
    }

    bus.on("compliteTask", this.reload);
  },
  beforeUnmount() {
    bus.off("compliteTask", this.reload);
  },
};
</script>

<style lang="scss" scoped>
.route-point {
  &__head {
    padding-bottom: 15px;
  }

  &__tasks {
    padding: 0;
    min-height: 60px;
  }
}
</style>
